import { ISelectItem } from '../Select';

export const timeSelectItems: ISelectItem[] = [
	{
		id: 0,
		value: 1,
		title: '1 ч.',
	},
	{
		id: 1,
		value: 12,
		title: '12 ч.',
	},
	{
		id: 2,
		value: 24,
		title: '24 ч.',
	},
	{
		id: 3,
		value: 48,
		title: '48 ч.',
	},
];
